import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y, filter: "blur(10px)" }}
    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span
    className={`font-display text-xs md:text-sm font-bold tracking-[0.28em] uppercase text-[#F5C542] ${className}`}
  >
    {children}
  </span>
);

export const SectionTitle = ({ chapter, children, className = "" }) => (
  <div className={className}>
    {chapter && (
      <span className="font-display text-sm tracking-[0.3em] text-white/30 block mb-3">
        {chapter}
      </span>
    )}
    <h2 className="font-display text-3xl md:text-5xl font-bold tracking-tight uppercase text-white leading-[1.05]">
      {children}
    </h2>
  </div>
);
